import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SurveyTemplateManager } from '@/components/surveys/SurveyTemplateManager';
import { SurveyBuilder } from '@/components/surveys/SurveyBuilder';
import { SurveyList } from '@/components/surveys/SurveyList';
import { CourseEffectivenessReport } from '@/components/surveys/CourseEffectivenessReport';
import { SurveyReports } from '@/components/surveys/SurveyReports';

export default function SurveyManagement() {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Survey Management</h1>
        <p className="text-muted-foreground mt-2">
          Create, manage, and analyze surveys for course evaluation and employee assessments.
        </p>
      </div>

      <Tabs defaultValue="surveys" className="space-y-6">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="surveys">Active Surveys</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="builder">Create Survey</TabsTrigger>
          <TabsTrigger value="effectiveness">Course Reports</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="surveys" className="space-y-6">
          <SurveyList 
            onEditSurvey={(survey) => console.log('Edit survey:', survey)}
            canManage={true}
          />
        </TabsContent>

        <TabsContent value="templates" className="space-y-6">
          <SurveyTemplateManager />
        </TabsContent>

        <TabsContent value="builder" className="space-y-6">
          <SurveyBuilder 
            onClose={() => console.log('Close builder')}
            onSave={(survey) => console.log('Save survey:', survey)}
          />
        </TabsContent>

        <TabsContent value="effectiveness" className="space-y-6">
          <CourseEffectivenessReport />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <SurveyReports />
        </TabsContent>
      </Tabs>
    </div>
  );
}